import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import VideoSection from './sections/VideoSection';
import WhyVtrenderSection from './sections/WhyVtrenderSection';
import InsidePlatformSection from './sections/InsidePlatformSection';
import FeatureGridSection from './sections/FeatureGridSection';
import VideoFeaturesSection from './sections/VideoFeaturesSection';
import SocialProofSection from './sections/SocialProofSection';
import FooterSection from './sections/FooterSection';
import CountdownBar from './demo-upgrade/sections/CountdownBar';
import DemoHeroSection from './demo-upgrade/sections/HeroSection';
import FeaturedPlan from './demo-upgrade/sections/FeaturedPlan';
import Testimonials from './demo-upgrade/sections/Testimonials';
import FeatureComparison from './demo-upgrade/sections/FeatureComparison';
import FAQ from './demo-upgrade/sections/FAQ';
import TrustBadges from './demo-upgrade/sections/TrustBadges';
import DemoFooter from './demo-upgrade/sections/Footer';
import './LandingPage.css';
import './demo-upgrade/DemoUpgradeLandingPage.css';
import Header from '../../pages/login-register/components/header';
import useDemoEligibility from './demo-upgrade/useDemoEligibility';
import YearRecapPopup from '../YearRecapPopup';
const LandingPage = () => {
  const { isChecking, isEligible, demoData } = useDemoEligibility();
  const [showYearRecap, setShowYearRecap] = useState(false);

  useEffect(() => {
    if (isEligible) {
      document.title = "Elite Demo Member Exclusive - Use Code DEMO35 | Vtrender™ Charts";
    } else {
      document.title = "Vtrender™ Charts";
    }
  }, [isEligible]);

  // Show loading state while checking
  if (isChecking) {
    return null;
  }

  // Show demo upgrade landing page if eligible
  if (isEligible) {
    const minutesRemaining = demoData?.minutesRemaining || 0;
    const expiryTime = new Date(Date.now() + minutesRemaining * 60 * 1000).getTime();

    return (
      <div className="demo-upgrade-landing-page landing-page">
        <CountdownBar expiryTime={expiryTime} />
        <DemoHeroSection />
        <FeaturedPlan />
        <Testimonials />
        <FeatureComparison />
        <FAQ />
        <TrustBadges />
        <DemoFooter />
      </div>
    );
  }

  // Show normal landing page if not eligible
  return (
    <div className="landing-page">
      <Header showIntro={true} showBoth={true} />
      <HeroSection />
      <VideoFeaturesSection />
      <WhyVtrenderSection />
      <InsidePlatformSection />
      <FeatureGridSection />
      <SocialProofSection />
      {/* <PricingSection /> */}
      <VideoSection />
      <FooterSection />
      {/* <YearRecapPopup 
        open={showYearRecap}
        onClose={() => setShowYearRecap(false)}
        delayMs={1200}
      /> */}
    </div>
  );
};

export default LandingPage;
